<div class="loader-overlay">
  <div class="loader-overlay__spinner"><ion-spinner mode="md" name="crescent"></ion-spinner></div>
</div>
